import { usePaymentContext } from "@/context-state/PaymentContext"

export const useEntitlementsAvailability = (entitlementKey) => {
    const { checkEntitlementAvailable, getEntitlementByKey } = usePaymentContext()

    const { available, type } = checkEntitlementAvailable(entitlementKey)
    const entitlement = getEntitlementByKey(entitlementKey)

    return { available, type, entitlement }
}